import * as STD from '@emersya/mpa-std';
import { Modal } from '@emersya/mpa-components';
import * as CM from '@emersya/mpa-components-manager';

export interface IHowToUseModalComponentConfiguration extends Modal.Configuration {
};

export class HowToUseModalComponent extends Modal.Component<
null,
null
> {

    protected override canBeClosed() : boolean {
		return true;
	};

	protected override onOpen() {
	};

	protected override onClose() {
	};

	protected override async onValidate(){
		// await so build don't stop on it
		await Promise.resolve();
		return null;
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IHowToUseModalComponentConfiguration
	)
	{
		super(descriptor, configuration);
        this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};
};
export namespace NS {
	export const Component = HowToUseModalComponent;
	export type Component = HowToUseModalComponent;
	export type Configuration = IHowToUseModalComponentConfiguration;
}
;
import manifestXMLSource                   from './HowToUseModal.xml';
import './HowToUseModal.scss';

CM.Manager.declare({
	id :       'howToUseModal',
	type :     HowToUseModalComponent,
	manifest : manifestXMLSource
});
